export default __webpack_public_path__ + "static/media/maxine_detail12.e6bd3f82.jpg";